// import Layout from '@/layout/index.vue'
import { businessRoute } from '@/router/modules/business'
export const staticRoute: any = [
  ...businessRoute
]
// export const staticRoute: any = [
//   {
//     component: () => import('@/layout/index.vue'),
//     meta: {
//       hidden: false,
//       icon: 'Report',
//       link: '',
//       target: null,
//       title: '任务管理'
//     },
//     name: 'store_manager',
//     path: '/business',
//     children: [
//       {
//         component: (resolve:any) => require(['@/views/business/taskManage/index.vue'], resolve),
//         meta: {
//           hidden: false,
//           icon: '',
//           link: '',
//           target: null,
//           title: '任务管理'
//         },
//         name: 'taskManage_list',
//         path: 'taskManage/index'
//       }
//       // {
//       //   component: (resolve:any) => require(['@/views/business/enterprise/index.vue'], resolve),
//       //   meta: {
//       //     hidden: false,
//       //     icon: '',
//       //     link: '',
//       //     target: null,
//       //     title: '标签管理'
//       //   },
//       //   name: 'store_enterprise',
//       //   path: 'business/enterprise/index'
//       // }
//     ]
//   }
// ]

// 一级菜单
export const tabDtoList = [
  { id: 1, tabCode: 'business', tabName: '业务应用' }
  // { id: 2, tabCode: 'business123', tabName: '业务应用122' }
]
export const menuList = [
  {
    id: 158,
    tabId: 2,
    pid: 0,
    component: 'Layout',
    hidden: false,
    name: 'store_manager',
    path: '/store',
    redirect: '',
    meta: {
      title: '门店管理',
      icon: 'Report',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 251,
    tabId: 2,
    pid: 158,
    component: 'business/store/main',
    hidden: false,
    name: 'store_list',
    path: 'business/store/main',
    redirect: '',
    meta: {
      title: '门店列表',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  },
  {
    id: 255,
    tabId: 2,
    pid: 158,
    component: 'business/enterprise/index',
    hidden: false,
    name: 'store_enterprise',
    path: 'business/enterprise/index',
    redirect: '',
    meta: {
      title: '标签管理',
      icon: '',
      link: '',
      show: true,
      target: null
    }
  }
]
